import { render, staticRenderFns } from "./ClonarProductoModalComponent.vue?vue&type=template&id=381f3b19&"
import script from "./ClonarProductoModalComponent.vue?vue&type=script&lang=js&"
export * from "./ClonarProductoModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports